import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozDimensions', bringozDimensions);

function bringozDimensions($filter) {
  return function bringozDimensionsFilter(dimensions, defaultValue, displayDefaultWhenZeroDimensions) {
    if (!dimensions) {
      return $filter('translate')(defaultValue);
    }

    if (_.isString(dimensions)) {
      dimensions = JSON.parse(dimensions);
    }

    let height = _.get(dimensions, 'height', '---');
    let width = _.get(dimensions, 'width', '---');
    let length = _.get(dimensions, 'length', '---');

    if (!!displayDefaultWhenZeroDimensions && (!height && !width && !length)) {
      return $filter('translate')(defaultValue);
    }

    height = height!=='---'? decimalNumberToFix(height):height;
    width = width!=='---'? decimalNumberToFix(width):width;
    length = length!=='---'? decimalNumberToFix(length):length;

    const translatedHeight = $filter('translate')('DIMENSIONS.H')
    const translatedWidth = $filter('translate')('DIMENSIONS.W');
    const translatedLength = $filter('translate')('DIMENSIONS.L');

    return height + translatedHeight + ' / ' + width + translatedWidth + ' / ' + length + translatedLength;
  }

  function decimalNumberToFix(num){
    return (num).toFixed(Number.isInteger(num) ? 0 : 2);
  }
}
